/**
 * @file index.js
 * @desc 法行宝全局store信息
 * @author sunxiaofeng01
 */
import $http from '../../../utils/ajax';
import {normalizeResponseData, normalizeResponseError} from '@/utils/normalize';
export default {
    namespaced: true,
    state: {
        // 百家号信息
        bjhInfo: {
            bjh_info: {}
        },
        // 用户信息
        userInfo: {},
        // 百家号入口跳转路径
        bjhNextPath: '',
        // 1:未认证
        // 2：认证审核中状态
        // 3：认证不通过状态
        // 4：认证完成但个人信息未完成
        // 5：认证完成但个人信息处于审核中
        // 6：已完成执业认证但【个人信息】审核失败
        // 7：已完成认证
        authenticationStatus: 0,
        // VIP信息，vipStatus为1是会员，0是非会员
        vipInfo: {},
        userInfoNew: {},
        // 经营等级信息
        manageInfo: {},
        // 代理商成员列表
        agentMemberData: [],
        // 引导弹窗类型
        guideType: '',
        // 智能体信息
        agentInfo: {},
        // 服务号二维码
        qrcodeUrl: '',
        // 智能体线索分配弹窗
        showConsultAgentModal: false // 程序生命周期内弹窗一次的标识
    },
    actions: {
        openWindow({commit, state, dispatch}, params = '') {
            commit('setBjhNextPath', '');
            if (params) {
                commit('setBjhNextPath', params);
            }
        },
        async getVipInfo({commit, state, dispatch}, params = {}) {
            await $http.get('/bp/api/vip/info').then(response => {
                const vipInfoData = response?.data || {};
                // privilege_info为当前或最近一个会员码的信息
                // 用vipStatus区分当前是否是会员，vipStatusName区分具体是什么会员
                const VipTypeMap = {
                    0: 'vip',
                    1: 'vcardVip', // v卡会员
                    6: 'freeVip', // 免费体验会员
                    8: 'eliteVip', // 精英会员
                    7: 'beginnerVip' // 启航会员
                };
                if (+vipInfoData.vipStatus) {
                    vipInfoData.vipStatusName = 'vip';
                    if (vipInfoData.privilege_info && +vipInfoData.privilege_info.vip_code_type) {
                        vipInfoData.vipStatusName
                            = VipTypeMap[+vipInfoData.privilege_info.vip_code_type] || 'vip';
                    }
                }
                else {
                    vipInfoData.vipStatusName = 'noVip';
                }
                // 当前非会员，且没有开过会员，且有免费体验会员资格，则能够领取免费体验会员
                if (!+vipInfoData.vipStatus
                    && !vipInfoData.validityEnd
                    && +vipInfoData.hasTrailVipQualify
                ) {
                    vipInfoData.canReceiveFreeVip = true;
                }
                if (vipInfoData) {
                    commit('setVipInfo', vipInfoData);
                }
            }).catch(err => normalizeResponseError(err));
        },
        getBjhInfo({commit, state, dispatch}, params = {}) {
            $http.get('/bp/api/bjh/info').then(response => {
                const bjhInfoData = normalizeResponseData(response);
                if (bjhInfoData) {
                    commit('setBjhInfo', bjhInfoData);
                }
            }).catch(err => normalizeResponseError(err));
        },
        getLawyerManageInfo({commit, state, dispatch}, params = {}) {
            return $http.get('/bp/api/manage/info').then(response => {
                const manageInfo = normalizeResponseData(response);
                if (manageInfo) {
                    commit('setManageInfo', manageInfo);
                }
                return manageInfo;
            }).catch(err => normalizeResponseError(err));
        },
        getLawAgreement({commit, state, dispatch}, params = {}) {
            const {product_type = '6'} = params;
            return $http.get('/bp/api/mid/agreement', {
                params: {
                    product_type
                }
            }).then(resp => normalizeResponseData(resp));
        },
        getUserInfoNew({commit, state, dispatch}, params = {}) {
            return new Promise((resolve, reject) => {
                $http.get('/bp/api/user/info').then(res => {
                    if (+res.code !== 0 || !res.data) {
                        resolve();
                        return;
                    }
                    // 已登录未认证状态 register_stage:0
                    // 认证审核中状态 register_stage:1 info_status:2
                    // 认证不通过状态 register_stage:1 info_status:6
                    // 认证完成但个人信息未完成 register_stage:1 info_status:4
                    // 认证完成但个人信息处于审核中 register_stage:2 info_status:2
                    // 已完成执业认证但【个人信息】审核失败 register_stage:2 info_status:6
                    // 已完成认证:register_stage:2 info_status:4
                    let authenticationStatus = 1;
                    let {register_stage, info_status} = res.data.lawyer_info || {};
                    if (+register_stage > 0) {
                        if (+info_status === 2) {
                            authenticationStatus = 2 + (+register_stage - 1) * 3;
                        }
                        else if (+info_status === 6) {
                            authenticationStatus = 3 + (+register_stage - 1) * 3;
                        }
                        else if (+info_status === 4) {
                            authenticationStatus = 4 + (+register_stage - 1) * 3;
                        }
                    }
                    if (+info_status === 10) {
                        authenticationStatus = 1;
                    }
                    resolve(res.data);
                    commit('setUserInfoNew', res.data || {});
                    commit('setAuthenticationStatus', authenticationStatus);
                }).catch(err => {
                    reject();
                });
            });
        },
        submitInfo({commit, state, dispatch}, params = {}) {
            const {lawyer_info} = state?.userInfoNew || {};
            const {appearance_config} = lawyer_info || {};
            return new Promise((resolve, reject) => {
                $http.post('/bp/api/user/save', {
                    init_source: 1,
                    ...lawyer_info,
                    ...appearance_config,
                    ...appearance_config && (appearance_config.color_config),
                    ...params,
                    register_stage: 2
                }).then(res => {
                    if (+res.code === 10002 && params && params.isIdea) {
                        resolve(res);
                        return;
                    }
                    if (+res.code !== 0) {
                        reject(res);
                        return;
                    }
                    dispatch('getUserInfoNew');
                    resolve(res);
                }).catch(err => {
                    reject();
                });
            });
        },
        saveAppearanceConfig({commit, state, dispatch}, params = {}) {
            const {lawyer_info} = state?.userInfoNew || {};
            const {appearance_config} = lawyer_info || {};
            return new Promise((resolve, reject) => {
                $http.post('/bp/api/user/saveappearanceconfig', {
                    init_source: 1,
                    ...lawyer_info,
                    ...appearance_config,
                    ...appearance_config && (appearance_config.color_config),
                    ...params
                }).then(res => {
                    if (+res.code !== 0) {
                        reject(res);
                        return;
                    }
                    dispatch('getUserInfoNew');
                    resolve(res);
                }).catch(err => {
                    reject();
                });
            });
        },
        getAgentMemberData({commit, state, dispatch}, params = {}) {
            return $http.get('/bp/firmsubaccount/list', {
                params: {
                    pn: 1,
                    // 下拉列表查询所有，给个较大值
                    rn: 10000
                }
            }).then(response => {
                const res = normalizeResponseData(response);
                let {list = []} = res;
                if (list) {
                    commit('setAgentMemberData', list);
                }
            }).catch(err => normalizeResponseError(err));
        },
        getAgentData({commit, state, dispatch}, params = {}) {
            return new Promise((resolve, reject) => {
                $http.get('/bp/api/lawyeragent/info', {
                }).then(res => {
                    if (!res.data || res.code !== '0') {
                        return;
                    }
                    resolve(res.data);
                    commit('setAgentInfo', res.data);
                }).catch(err => {});
            });
        },
        getQrcodeUrl({commit, state, dispatch}, params = {}) {
            return new Promise((resolve, reject) => {
                $http.get('/bp/api/wechat/getqrticket', params).then(res => {
                    res = normalizeResponseData(res);
                    const qrcodeUrl = res.qr_url || '';
                    commit('setQrcodeUrl', qrcodeUrl);
                }).catch(err => {});
            });
        }
    },
    mutations: {

        /**
         * 设置1v1咨询页弹窗状态
         *
         * @param {Object} state 状态树
         * @param {Object} info  1v1智能体创建状态
         */

        setConsultAgentModal(state, info) {
            state.showConsultAgentModal = info;
        },

        /**
         * 设置百家号信息
         *
         * @param {Object} state 状态树
         * @param {Object} info  百家号信息
         */
        setBjhInfo(state, info) {
            state.bjhInfo = info;
        },

        /**
         * 设置用户信息
         *
         * @param {Object} state 状态树
         * @param {Object} info  用户信息
         */
        setUserInfo(state, info) {
            state.userInfo = info;
        },

        /**
         * 设置用户信息
         *
         * @param {Object} state 状态树
         * @param {Object} info  用户信息
         */
        setUserInfoNew(state, info) {
            state.userInfoNew = info;
        },

        /**
         * 设置经营等级信息
         *
         * @param {Object} state 状态树
         * @param {Object} info  经营等级信息
         */
        setManageInfo(state, info) {
            state.manageInfo = info;
        },

        /**
         * 设置会员信息
         *
         * @param {Object} state 状态树
         * @param {Object} info  会员信息
         */
        setVipInfo(state, info) {
            state.vipInfo = info;
        },

        /**
         * 百家号跳转路径
         *
         * @param {Object} state 状态树
         * @param {Object} info  路径信息
         */
        setBjhNextPath(state, info) {
            state.bjhNextPath = info;
        },

        /**
         * 认证状态
         *
         * @param {Object} state 状态树
         * @param {Object} authenticationStatus  认证状态
         */
        setAuthenticationStatus(state, authenticationStatus) {
            state.authenticationStatus = authenticationStatus;
        },

        /**
         * 代理商成员列表
         *
         * @param {Object} data 列表
         */
        setAgentMemberData(state, data) {
            state.agentMemberData = data;
        },

        /**
         * 设置引导类型
         *
         * @param {Object} data 列表
         */
        setGuideType(state, data) {
            state.guideType = data;
        },
        // 设置智能体信息
        setAgentInfo(state, info) {
            state.agentInfo = info;
        },
        // 设置服务号信息
        setQrcodeUrl(state, data) {
            state.qrcodeUrl = data;
        }
    }
};
